<script setup lang="ts">
import { PopoverClose } from 'radix-vue'
import type { IClientType } from '~/components/PlusBlog/lp/atom/ClientTypeList/index.vue'

defineProps({
    list: Array as PropType<IClientType[]>,
})

const route = useRoute()
const isSoho = computed(() => {
    return !!route.path.includes('dla-firm')
})
const open = ref(false)
function handleOpen(val: boolean) {
    open.value = val
}
</script>

<template>
    <PlusBlogLpAtomPopover
        v-model:open="open"
        @update:open="handleOpen"
    >
        <PlusBlogLpAtomPopoverTrigger
            class="lp-label-md flex w-full items-center justify-between border p-3 text-left font-medium"
        >
            <span>{{ isSoho ? 'Małe firmy' : 'Klient Indywidualny' }}</span>
            <VIcon
                name="chevron-down"
                size="s"
                class="transition-transform duration-400"
                :class="{ 'rotate-180': open }"
            />
        </PlusBlogLpAtomPopoverTrigger>
        <PlusBlogLpAtomPopoverContent class="w-[--lp-radix-popover-trigger-width] p-3">
            <PlusBlogLpAtomClientTypeList
                :list="list"
                @handle-open="handleOpen"
            >
                <li class="pt-1">
                    <PopoverClose class="flex w-full justify-end">
                        <img
                            src="https://api.plus.pl/file/images_lp/plus_acse_landingpages/menu/close-dark.svg"
                            alt="close"
                        />
                    </PopoverClose>
                </li>
            </PlusBlogLpAtomClientTypeList>
        </PlusBlogLpAtomPopoverContent>
    </PlusBlogLpAtomPopover>
</template>
